import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const Row = styled.div<{
  highlight?: boolean
  strikethrough?: boolean
  end?: boolean
}>(
  {
    border: 0,
    borderTop: `${tokens.borderWidth.xs} dashed ${tokens.color.airJordan[300]}`,
    fontSize: tokens.fontSize[1],
    padding: `${tokens.spacing[4]} 0`,
    display: 'flex',
    alignItems: 'center',
    flex: `1 1 12.5rem`
  },
  ({ highlight }) =>
    highlight && {
      color: tokens.color.airJordan.p
    },
  ({ strikethrough }) =>
    strikethrough && {
      textDecoration: 'line-through'
    },
  ({ end }) =>
    end && {
      paddingBottom: 0
    }
)

export const Detail = styled.span({
  marginLeft: 'auto'
})
